import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import HostDashboard from "@/pages/HostDashboard";
import Wizard from "@/pages/Wizard";
import TournamentManage from "@/pages/TournamentManage";
import AdminDashboard from "@/pages/AdminDashboard";
import PublicTournament from "@/pages/PublicTournament";
import CaptainView from "@/pages/CaptainView";
import TeamView from "@/pages/TeamView";
import RefereeView from "@/pages/RefereeView";
import TeamInvite from "@/pages/TeamInvite";

function Protected({ children, role }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex h-screen items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/host"} replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/host" element={<Protected role="host"><HostDashboard /></Protected>} />
            <Route path="/host/new" element={<Protected role="host"><Wizard /></Protected>} />
            <Route path="/host/t/:id" element={<Protected role="host"><TournamentManage /></Protected>} />
            <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
            <Route path="/t/:code" element={<PublicTournament />} />
            <Route path="/c/:code" element={<CaptainView />} />
            <Route path="/m/:code" element={<TeamView />} />
            <Route path="/r/:code" element={<RefereeView />} />
            <Route path="/join/:code" element={<TeamInvite />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
